import { getUtilityPopupContainer } from './utility-popups';

function openUtilityPopup( popupElement: Element ): void {
    const container = getUtilityPopupContainer();
    popupElement.classList.add( 'popup__container--open' );
    container.classList.add( 'popup__wrapper--open' );
    document.body.classList.add( 'utility-popup-open' );

    popupElement.dispatchEvent( new CustomEvent( 'twc:newcontentloaded', {
        bubbles: true,
        detail: {
            container: container,
        },
    } ) );
}

function closeAllUtilityPopups( closeContainer = true ): void {
    const container = document.querySelector<HTMLElement>( '.popup__wrapper--open' );

    if ( !container ) {
        return;
    }

    if ( closeContainer ) {
        container.classList.remove( 'popup__wrapper--open' );
        document.body.classList.remove( 'utility-popup-open' );
    }

    container.querySelectorAll<HTMLElement>( '.popup__container--open' ).forEach( ( popup: HTMLElement ) => {
        if ( popup.dataset.onClose && popup.dataset.onClose === 'remove' ) {
            popup.remove();
        } else {
            popup.classList.remove( 'popup__container--open' );
        }

        popup.dispatchEvent( new CustomEvent( 'twc:popup:close-utility-popup' ) );
    } );

    if ( container.querySelectorAll( '.popup__container' ).length === 0 ) {
        container.remove();
    }
}

function anyPopupOpen(): boolean {
    return pagePopupOpen() || utilityPopupOpen();
}

function pagePopupOpen(): boolean {
    return document.body.classList.contains( 'page-popup-open' );
}

function utilityPopupOpen(): boolean {
    return document.body.classList.contains( 'utility-popup-open' );
}

function confirmationPopupOpen(): boolean {
    return document.querySelector( '.notification-popup' ) !== null;
}

function getConfirmationPopup(): HTMLElement | null {
    if ( !confirmationPopupOpen() ) {
        return null;
    }

    return document.querySelector<HTMLElement>( '.notification-popup' );
}

function closeConfirmationPopup(): void {
    const popup = getConfirmationPopup();

    if ( !popup ) {
        return;
    }

    popup.remove();
}

function getOpenUtilityPopup(): HTMLElement | null {
    if ( !utilityPopupOpen() ) {
        return null;
    }

    return document.querySelector( '#utility-popup-container .popup__container--open' );
}

function onScrollWithTimeout( callback: EventListener ): EventListener {
    let scrollingTimeout: number | null = null;

    return function( event: Event ): void {
        if ( scrollingTimeout !== null ) {
            window.clearTimeout( scrollingTimeout );
        }

        scrollingTimeout = window.setTimeout( function() {
            callback( event );
            scrollingTimeout = null;
        }, 250 );
    };
}

function getScrollingElement( element: Element ): HTMLElement | Window | null {
    const popupScroller = element.closest<HTMLElement>( '.pagepopup__scrollcontainer' );

    if ( popupScroller ) {
        return popupScroller;
    }

    return window;
}

export {
    closeAllUtilityPopups,
    openUtilityPopup,
    anyPopupOpen,
    pagePopupOpen,
    utilityPopupOpen,
    onScrollWithTimeout,
    getOpenUtilityPopup,
    getScrollingElement,
    confirmationPopupOpen,
    getConfirmationPopup,
    closeConfirmationPopup,
};
